export const NEWSPAPER_LINK = [
  'https://techcrunch.com/2019/01/13/a-first-look-at-twitters-new-beta-app-and-its-bid-to-remain-valuable-and-relevant/',
  'https://forbesvietnam.com.vn/tin-cap-nhat/nhung-startup-cong-nghe-dang-luu-y-tai-ces-2019-5114.html',
  'https://www.techinasia.com/top-funded-startups-tech-companies-singapore',
  'https://giaoducthoidai.vn/giao-duc/bo-gddt-lay-y-kien-gop-y-cho-du-thao-luat-gd-sua-doi-ban-hanh-quy-che-phat-ngon-3975913-v.html',
  'https://dantri.com.vn/giao-duc-khuyen-hoc/4512-hoc-sinh-thpt-tranh-tai-trong-ky-thi-hoc-sinh-gioi-quoc-gia-2019-20190114090220374.htm',
  'https://tuoitre.vn/hhen-nie-tung-mo-thanh-co-hang-ve-chai-2019011320074363.htm'
];
